import { Fragment } from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'dibs-react-intl';
import { handleMinimumFractionDigits } from 'dibs-buyer-price/exports/FormattedPrice';
import { SearchTag } from 'dibs-elements/exports/SearchTag';

import {
    isStatsFilter,
    isPriceFilter,
    isDimensionFilter,
    isFreeShippingFilter,
    constructStatsRange,
    isDeliveredByFilter,
    isLocalPickupFilter,
} from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';
import { sbSharedRefineMenuMessages } from '../SbSharedRefineMenu/sbSharedRefineMenuMessages';

import styles from './SbMobileAppliedFiltersItem.scss';

function SbMobileAppliedFiltersItemComponent(props) {
    const {
        appliedValue,
        filterName,
        availableValues,
        onCloseClick,
        currency,
        titleMessage,
        measurementUnit,
        localizedFilterValue,
    } = props;
    const intl = useIntl();
    const displayName = get(appliedValue, 'displayName', null);
    const hexCode = get(appliedValue, 'hexCode', null);
    const urlLabel = get(appliedValue, 'urlLabel', null);
    let colorBubble = null;
    let value = displayName;
    let dimension = null;
    let title = titleMessage;

    if (isDimensionFilter(filterName)) {
        dimension = <span className={styles.dimension}>{measurementUnit.toLowerCase()}</span>;
    }

    if (isStatsFilter(filterName)) {
        const [min, max] = constructStatsRange(
            urlLabel,
            get(availableValues, '[0].displayName')
        ).map(rangeValue => {
            if (isPriceFilter(filterName)) {
                return intl.formatNumber(rangeValue, {
                    style: 'currency',
                    currency,
                    minimumFractionDigits: handleMinimumFractionDigits(rangeValue),
                });
            } else {
                return rangeValue;
            }
        });

        value = (
            <Fragment>
                {min}&nbsp;{sbSharedRefineMenuMessages.TO}&nbsp;{max}
            </Fragment>
        );
    } else if (isDeliveredByFilter(filterName)) {
        value = (
            <FormattedMessage
                id="sb.SbRespAppliedFiltersItem.valueWithinDays"
                defaultMessage="Within {displayName} Days"
                values={{ displayName }}
            />
        );
    } else if (isLocalPickupFilter(filterName)) {
        value = localizedFilterValue;
    } else if (isFreeShippingFilter(filterName)) {
        title = sbSharedRefineMenuMessages.shippingOptions;
        value = sbSharedRefineMenuMessages.shippingFree;
    }

    if (hexCode) {
        colorBubble = <span className={styles.colorBubble} style={{ backgroundColor: hexCode }} />;
    }

    return (
        <div className={styles.filterItemWrapper}>
            <SearchTag dataTn={`filter-${filterName}`} onDelete={onCloseClick}>
                {appliedValue && (
                    <div className={styles.filterItemContent} data-tn={`value-${filterName}`}>
                        {colorBubble}
                        {value || title}
                        {dimension}
                    </div>
                )}
            </SearchTag>
        </div>
    );
}

SbMobileAppliedFiltersItemComponent.propTypes = {
    currency: PropTypes.string.isRequired,
    filterName: PropTypes.string.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    availableValues: PropTypes.arrayOf(
        PropTypes.shape({
            displayName: PropTypes.string.isRequired,
        })
    ).isRequired,
    appliedValue: PropTypes.shape({
        displayName: PropTypes.string.isRequired,
        hexCode: PropTypes.string,
    }),
    titleMessage: PropTypes.string.isRequired,
    measurementUnit: PropTypes.string,
    localizedFilterValue: PropTypes.string,
};

export const SbMobileAppliedFiltersItem = SbMobileAppliedFiltersItemComponent;
